<div class="pdf-view-content pdf-only">
    <div class="pdf-view-header">
        <div class="pdf-view-title-section">
            <div>
                <h2 class="pdf-view-title">Print Transfer Form</h2>
               
            </div>
        </div>
        <button class="icon-btn" [pTooltip]="translate?.general.buttons.close.singular" (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="pdf-view-header cta">
            <div class="pdf-view-actions">
              
               <p-button 
                    class="print-job-sheet__download-btn"
                    styleClass="h-32" 
                    icon="fa-regular fa-download" 
                    [pTooltip]="translate?.general.buttons.download.singular" 
                    tooltipPosition="top"
                    (onClick)="onDownload()">
                    </p-button> 
                 </div>
    </div>
    <div class="pdf-view-left">
        <div class="pdf-preview-container-only">

            <!-- ✅ PDF with parameters to hide sidebar and zoom in -->
            <iframe
            [src]="safeFileUrl"
            class="pdf-iframe"
            type="application/pdf">
            </iframe>

            

        </div>
</div>
</div>